import React from 'react';
import './FaceSwapIntro.css';

const FaceSwapIntro: React.FC = () => {
  return (
    <section className="face-swap-intro">
      <div className="intro-content">
        <h1 className="intro-title">Best AI Face Swap</h1>
        <p className="intro-description">
          Transform faces instantly with powerful AI technology - simple, fast, and professional.
        </p>
      </div>
    </section>
  );
};

export default FaceSwapIntro;
